export enum IconSize {
    SIZE_32,
    SIZE_24,
    SIZE_16
}
